module.exports = __webpack_public_path__ + "img/arrow_left_2.3fd4936e.svg";